<template>
  <section>
    <h3 v-if="user">
      {{ $t('message.credit.total_available_credits') }}: {{ user.totalCredits | currency }}
    </h3>
    <hr class="my-4">
    <label>{{ $t('message.credit.transaction_history') }}</label>
    <div v-if="creditTransactions && creditTransactions.length > 0">
      <div class="card panel-inbox">
        <div class="card-body">
          <ul class="list-unstyled">
            <template v-for="(creditTransaction, index) in creditTransactions">
              <li class="card-body" :key="index">
                <div class="row">
                  <div class="col-2">
                    <div class="avatar-container small">
                      <template v-if="creditTransaction.referral_user">
                        <img v-lazy="creditTransaction.referral_user.picture"
                             class="rounded-circle message-user-img">
                      </template>
                      <template v-else>
                        <img v-lazy="creditTransaction.user.picture"
                             class="rounded-circle message-user-img">
                      </template>
                    </div>
                  </div>
                  <div class="col-7">
                    <label class="mb-0" v-if="creditTransaction.referral_user">
                      {{ creditTransaction.referral_user.full_name | firstName }}
                    </label>
                    <label class="mb-0" v-else>
                      {{ creditTransaction.user.full_name | firstName }}
                    </label>
                    <div>
                      {{ creditTransaction.credit_action_type | multiLangName }}
                      <span v-if="creditTransaction.order">#{{ creditTransaction.order.order_code }}</span>
                    </div>
                    <div class="text-remark text-secondary mt-2" v-if="creditTransaction.created_at">
                      <i class="fal fa-clock"></i> {{ creditTransaction.created_at | prettyDate }}
                    </div>
                    <div class="mt-2" v-if="creditTransaction.expire_date">
                      {{ $t('message.credit.expired_on') }} {{ creditTransaction.expire_date | prettyOnlyDate }}
                    </div>
                  </div>
                  <div class="col-3 text-right justify-content-center align-self-center">
                    <div v-html="$options.filters.credits(creditTransaction)"></div>
                    <div class="text-remark -status-offline" v-if="creditTransaction.credit_type === 'pending' || creditTransaction.credit_type === 'expired'">
                      {{ creditTransaction.credit_type }}
                    </div>
                  </div>
                </div>
              </li>
            </template>
          </ul>
        </div>
      </div>
      <div class="text-center">
        <button class="button -cyan"
                :disabled="isFetching"
                @click="fetchCreditTransactions()"
                v-if="isMore">
          {{ isFetching ? $t('message.button.loading') :  $t('message.button.load_more') }}
        </button>
      </div>
    </div>

    <div v-else>
      <div class="text-center mt-5">
        <h3>{{ $t('message.invite_friends.no_credit_transaction') }}</h3>
        <div class="row my-4">
          <div class="col-12">
            {{ $t('message.invite_friends.earning_credit_remark', { credits: globalState.configData.invite_friend_credits }) }}
          </div>
        </div>
        <router-link to="/user/invite" class="btn btn-info">
          {{ $t('message.invite_friends.invite_your_friends') }}
        </router-link>
      </div>
    </div>

  </section>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    data () {
      return {
        queryData: {
          page: 0,
          user_id: null
        }
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        user: 'auth/getUser'
      }),
      ...mapState('credit', ['creditTransactions', 'isFetching', 'isMore'])
    },
    methods: {
      fetchCreditTransactions () {
        this.queryData.page++
        this.$store.dispatch('credit/LOAD_CREDIT_TRANSACTIONS', this.queryData)
      }
    },
    mounted () {
      this.queryData.user_id = this.user.id
      this.$store.dispatch('credit/LOAD_CREDIT_TRANSACTIONS', this.queryData)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/Credit.vue